import React from 'react';

function Footer() {
  return (
    <footer className="py-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center">
          <p className="text-gray-600 text-sm">© 2025 Moolmit Tattoo. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
